import React from 'react';
import styled from 'styled-components';

// config
import { buttonStyles } from '~/App/config/buttonStyles';
import { mq } from '~/lib/mq';
import { externalLinks } from '~/App/config/externalLinks';

// shared components
import { SubHeroText } from '../../SubHeroText';

import { PrimaryButton, ButtonWrapper } from '../../Styled';
import { ViewWrapper } from '../../ViewWrapper';
import { HeroVariant } from '../../Hero';

type StylingProps = {
  hideMobile?: boolean;
};

const SecondSection = styled.div`
  margin-top: 3rem;
`;

const Styling = styled.p<StylingProps>`
  display: ${({ hideMobile }) => (hideMobile ? 'none' : 'block')};

  ${mq('≥mediumLarge')`
      display: block;
      margin: 0;
	    font-weight: ${({ theme }) => theme.fontWeights.regular};
	    width: 100%;
    `}
`;

export function Researcher() {
  const heroType: HeroVariant = 'researcher';

  return (
    <ViewWrapper hero={heroType} footer>
      <SubHeroText hero={heroType} />
      <ButtonWrapper>
        <PrimaryButton
          rel="noopener noreferrer"
          target="_blank"
          buttonType="link"
          to={externalLinks.researcher.loginFenix}
          children="Logga in hos Fenix"
        />
        <PrimaryButton
          rel="noopener noreferrer"
          target="_blank"
          buttonType="link"
          buttonStyle={buttonStyles.outlinePrimary}
          to={externalLinks.researcher.createAccountFenix}
          children="Skapa konto hos Fenix"
        />
      </ButtonWrapper>
      <SecondSection>
        <Styling>Är du bedömare av forskningsanslag?</Styling>
        <ButtonWrapper>
          <PrimaryButton
            rel="noopener noreferrer"
            target="_blank"
            buttonType="link"
            to={externalLinks.researcher.loginAssessor}
            children="Logga in som bedömare"
          />
        </ButtonWrapper>
      </SecondSection>
    </ViewWrapper>
  );
}
